import Odd from '@models/offer/Odd';

import { OfferType } from './enums';

export default class Market {
    id: number;
    // when we have special bet values
    uniqueId?: string;
    originalName: string;
    name: string;
    odds: Odd[] = [];
    isLocked = false;
    order: number;
    tags: string;
    readonly isSuperbet: boolean;

    constructor({
        id,
        name,
        order,
        isLocked = false,
        odds = [],
        tags = '',
        uniqueId = '',
        originalName = '',
        isSuperbet,
    }: {
        id: number;
        name: string;
        order: number;
        isLocked?: boolean;
        odds?: Odd[];
        tags?: string;
        uniqueId?: string;
        originalName?: string;
        isSuperbet: boolean;
    }) {
        this.id = id;
        this.name = name;
        this.odds = odds;
        this.isLocked = isLocked;
        this.order = order;
        this.tags = tags;
        this.uniqueId = uniqueId;
        this.originalName = originalName;
        this.isSuperbet = isSuperbet;
    }

    get isMain(): boolean {
        return this.odds[0] && this.odds[0].isMain() || false;
    }

    get isInPromotion(): boolean {
        return this.odds[0] && this.odds[0].isInPromotion || false;
    }

    get isLiveMarket(): boolean {
        return this.odds.every((odd) => odd.offerType === OfferType.live);
    }

    public containsAttribute(attribute: string): boolean {
        return this.tags.includes(attribute);
    }

    public isMarketType(marketName: string): boolean {
        if (this.odds.length === 0) {
            return false;
        }
        return this.odds[0].hasMarketTag(marketName);
    }
}
